import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import style from './CardSellerProperties.module.css';

const CardSellerProperties = ({ property }) => {

  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (property.id) {
      axios.get(`/properties/${property.id}/comments`)
        .then(res => {
          const comments = Array.isArray(res.data) ? res.data : [];
          setUnreadCount(comments.filter(c => !c.leido).length);
        })
        .catch(() => {});
    }
  }, [property.id]);

  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

    // Calcular días publicados
    const getDaysPublished = () => {
      if (!property.createdAt) return "Fecha desconocida";
  
      const createdAtDate = new Date(property.createdAt);
      const currentDate = new Date();
      const differenceInTime = currentDate.getTime() - createdAtDate.getTime();
      const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24)); // Convertir ms a días
  
      return differenceInDays === 1 ? "1 día publicado" : `${differenceInDays} días publicados`;
    };
  
    const getFormattedDate = (dateString) => {
      if (!dateString) return "Fecha desconocida";
    
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    };

    const getExpirationInfo = () => {
      if (!property.expirationDate) return null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const expDate = new Date(property.expirationDate);
      expDate.setHours(0, 0, 0, 0);
      const diffMs = expDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffMs / (1000 * 3600 * 24));
      if (diffDays > 0) {
        return { text: `Faltan ${diffDays} día${diffDays !== 1 ? 's' : ''} para vencer`, status: diffDays <= 30 ? 'warning' : 'ok' };
      } else if (diffDays === 0) {
        return { text: 'Vence hoy', status: 'warning' };
      } else {
        return { text: `Vencido hace ${Math.abs(diffDays)} día${Math.abs(diffDays) !== 1 ? 's' : ''}`, status: 'expired' };
      }
    };

    const expirationInfo = getExpirationInfo();
  
    


  return (
    <div className={style.card}>
      <div className={style.imageContainer}>
        {property?.photo?.length > 0 && (
          <img src={property.photo[0]} className={style.image} alt={property.title} />
        )}
        <span className={style.propertyId}>ID: {property.id}</span>
        {property.propertyType && (
          <span className={style.propertyTypeBadge}>{property.propertyType}</span>
        )}
      </div>
      <div className={style.cardContent}>
        <div className={style.cardHeader}>
          <h5 className={style.cardTitle}>{property.title}</h5>
          <span className={`${style.statusBadge} ${property.statusProperty ? style.statusActive : style.statusPending}`}>
            {property.statusProperty ? 'Aprobada' : 'Pendiente'}
          </span>
          {unreadCount > 0 && (
            <span className={style.commentBadge}>
              💬 {unreadCount} nuevo{unreadCount !== 1 ? 's' : ''}
            </span>
          )}
        </div>
        <h5 className={style.cardPrice}>{property.currency} {formatPrice(property.price)}</h5>
        <p className={style.dateInfo}>
          Creado el <strong>{getFormattedDate(property.createdAt)}</strong> — {getDaysPublished()}
        </p>

        <div className={style.comercializacion}>
          <div className={style.comercializacionRow}>
            <span className={style.comercializacionLabel}>📅 Comercialización:</span>
            <span>{property.availableDate ? getFormattedDate(property.availableDate) : 'Sin definir'}</span>
            <span className={style.comercializacionSep}>→</span>
            <span>{property.expirationDate ? getFormattedDate(property.expirationDate) : 'Sin definir'}</span>
          </div>
          {expirationInfo && (
            <span className={`${style.expirationBadge} ${style[expirationInfo.status]}`}>
              {expirationInfo.text}
            </span>
          )}
        </div>

        {property.description && (
          <p className={style.cardText}>{property.description.length > 120 ? property.description.substring(0, 120) + '...' : property.description}</p>
        )}

        <div className={style.cardMeta}>
          {property.totalSquareMeters > 0 && <span className={style.metaItem}>📐 {property.totalSquareMeters} m²</span>}
          {property.rooms > 0 && <span className={style.metaItem}>🛏️ {property.rooms} dorm.</span>}
          {property.bathrooms > 0 && <span className={style.metaItem}>🚿 {property.bathrooms} baños</span>}
          {property.garages > 0 && <span className={style.metaItem}>🚗 {property.garages} coch.</span>}
        </div>

        <div className={style.buttonContainer}>
        <Link to={`/historial/visitas/${property.id}`} className={style.detailsLink}>
    <button className={style.detailsButton}>Historial Visitas</button>
  </Link>
  <Link to={`/visita/${property.id}`} className={style.detailsLink}>
    <button className={style.detailsButton}>Anotar Visita</button>
  </Link>
  <Link to={`/detalles/${property.id}`} className={style.detailsLink}>
    <button className={style.detailsButton}>Ver detalles</button>
  </Link>
  <Link 
  to={`https://byraices.com/detail/${property.id}`} 
  className={style.detailsLink}
>
  <button 
    className={`${style.detailsButton} ${!property.statusProperty ? style.disabledButton : ""}`}
    disabled={!property.statusProperty}
    title={!property.statusProperty ? "Propiedad no aprobada" : ""}
  >
    Ver en página web
  </button>
</Link>
  <Link to={`/cierre-property/${property.id}`} className={style.detailsLink}>
            <button className={style.closeButton}>Cerrar Propiedad</button>
          </Link>
          {/* <Link to={`/generar-alquiler/${property.id}`} className={style.detailsLink}>
            <button className={style.rentalButton}>Generar Alquiler</button>
          </Link> */}
</div>
      </div>
    </div>
  );
};

export default CardSellerProperties;

